import { render } from "./Footer.vue?vue&type=template&id=c8df00bc&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=c8df00bc&lang=scss"

import exportComponent from "/Volumes/Media/WebDevelop/enfint-email/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__